import { useState } from "react";

import { NavLink, useNavigate } from "react-router-dom";

import {
  CircleHelp,
  CircleUser,
  CreditCard,
  Heart,
  LogOut,
  MapPin,
  Package,
  Settings,
  User,
} from "lucide-react";

import ConfirmLogout from "../../Utils/ConfirmLogout";
import { useGlobalContext } from "../../Context/GlobalContext";

import { broadcastLogout, clearAuthStorage } from "../../Utils/LogoutWatcher";

const menu = [
  {
    name: "My Account",
    path: "/account",
    icon: CircleUser,
    end: true,
  },
  {
    name: "Profile",
    path: "/account/profile",
    icon: User,
  },
  {
    name: "Orders",
    path: "/account/orders",
    icon: Package,
  },
  {
    name: "Saved Addresses",
    path: "/account/address",
    icon: MapPin,
  },
  // {
  //   name: "Favorite",
  //   path: "/account/favourite",
  //   icon: Heart,
  // },
  // {
  //   name: "Payment Mode",
  //   path: "/account/payment",
  //   icon: CreditCard,
  // },
  {
    name: "Help & Support",
    path: "/account/help",
    icon: CircleHelp,
  },
  // {
  //   name: "Settings",
  //   path: "/account/settings",
  //   icon: Settings,
  // },
];

export default function AccountSidebar({ sidebarOpen, setSidebarOpen }) {
  const navigate = useNavigate();

  const { logoutUser, clearSelectedRestaurant } = useGlobalContext();

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleConfirmLogout = () => {
    if (isLoggingOut) {
      return;
    }

    setIsLoggingOut(true);

    logoutUser?.();
    clearSelectedRestaurant?.();

    clearAuthStorage();
    broadcastLogout();

    setIsLogoutModalOpen(false);
    setSidebarOpen?.(false);

    navigate("/login", {
      replace: true,
      state: {
        loggedOut: true,
      },
    });

    window.setTimeout(() => {
      clearAuthStorage();
      setIsLoggingOut(false);
    }, 0);
  };

  return (
    <>
      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside
        //   className={`
        //     fixed left-0 top-0 z-50
        //     h-screen w-[280px]
        //     overflow-hidden
        //     rounded-none border-r bg-white shadow-xl
        //     transition-transform duration-300 ease-in-out

        //     lg:static lg:z-auto
        //     lg:h-fit lg:w-[250px]
        //     lg:translate-x-0
        //     lg:rounded-2xl lg:border lg:shadow-sm

        //     ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
        //   `}
        // >
        className={`
  fixed lg:sticky
  top-0 lg:top-[120px]
  left-0 lg:left-[max(calc((100vw-80rem)/2+1rem),1rem)]
  z-50

  w-[280px] lg:w-[250px]
  h-screen lg:h-[360px]

  bg-white
  rounded-none lg:rounded-2xl
  border-r lg:border
  overflow-y-auto

  shadow-xl lg:shadow-sm
  transition-transform duration-300

  ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
`}
      >
        {/* Mobile Header */}
        <div className="flex items-center justify-between border-b p-5 pt-36 lg:hidden">
          <h3 className="text-lg font-semibold">My Account</h3>
        </div>

        {/* Menu */}
        {menu.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              onClick={() => {
                if (window.innerWidth < 1024) {
                  setSidebarOpen(false);
                }
              }}
              className={({ isActive }) =>
                `flex items-center gap-3 border-b px-5 py-4 transition-colors ${
                  isActive
                    ? "bg-[#21195A] font-medium text-white"
                    : "text-gray-700 hover:bg-gray-50"
                }`
              }
            >
              <Icon size={20} />
              <span>{item.name}</span>
            </NavLink>
          );
        })}

        {/* Logout */}
        <button
          type="button"
          onClick={() => setIsLogoutModalOpen(true)}
          className="flex w-full items-center gap-3 px-5 py-4 text-gray-700 transition hover:bg-red-50 hover:text-red-500"
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </aside>

      <ConfirmLogout
        isOpen={isLogoutModalOpen}
        isLoggingOut={isLoggingOut}
        onClose={() => {
          if (!isLoggingOut) {
            setIsLogoutModalOpen(false);
          }
        }}
        onConfirm={handleConfirmLogout}
      />
    </>
  );
}
